module.exports = __webpack_public_path__ + "img/gigwicat3.0a2b464b.jpg";